import React from 'react';
import { Redirect } from 'react-router-dom'; 
import Login from '../components/Login';





const Page = ({   history, isAuthenticated }) => {
    if (isAuthenticated) return <Redirect to="/" />
 
    return (
        <div className="login">  
             <Login history={history}   />
        </div>
    );
}





export default Page; 
 
